import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { ValidationError } from '../../components';

import css from './FieldSelect.module.css';

import Select from 'react-select';

// Helper to convert <option> children to react-select options
const childrenToOptions = children => {
  return React.Children.toArray(children)
    .filter(child => React.isValidElement(child) && child.type === 'option')
    .map(child => ({
      value: child.props.value,
      label: child.props.children,
      disabled: child.props.disabled,
    }));
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    border: 0,
    // border: state.isFocused ? '2px solid var(--primary-600)' : provided.border,
    borderColor: state.isFocused ? 'var(--primary-600)' : provided.borderColor,
    borderRadius: 8,
    minHeight: 40,
    background: '#fff',
    paddingLeft: 0,
    '&:hover': {
      borderColor: 'var(--primary-600)',
    },
  }),

  placeholder: (provided) => ({
    ...provided,
    color: '#B0B7C3',
    fontSize: 15,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 20,
    minWidth: 170,
  }),
};

// Custom Option component for react-select
const CustomOption = props => {
  const { innerRef, innerProps, isFocused, isSelected, data } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
        background: isSelected ? '#F5F5F5' : isFocused ? '#F5F5F5' : '#fff',
        cursor: 'pointer',
        borderRadius: isFocused || isSelected ? 0 : 0,
        border: isSelected ? '0px solid #A259FF' : 'none',
        margin: '2px 0',
        position: 'relative',
      }}
    >
      {/* {data.avatarUrl ? (
        <img src={data.avatarUrl} alt={data.label} style={{ width: 24, height: 24, borderRadius: '50%', marginRight: 8 }} />
      ) : (
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#eee', marginRight: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, color: '#888' }}>
          {data.label ? data.label[0] : '?'}
        </div>
      )} */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 8 }}>
        <div style={{ fontWeight: 500, color: '#101828', fontSize: 16 }}>{data.label}</div>
        <div style={{ color: '#535862', fontSize: 16, fontWeight: 400 }}>{data.handle ? `@${data.handle}` : ''}</div>
      </div>
      {isSelected && (
        <span style={{ color: '#CA3839', fontSize: 18, marginLeft: 8, marginRight: 0, display: 'flex', alignItems: 'center' }}>✓</span>
      )}
    </div>
  );
};




const FieldSelectComponent = props => {
  const {
    rootClassName,
    className,
    selectClassName,
    id,
    label,
    input,
    meta,
    children,
    onChange,
    srOnly,
    helperText,
    placeholder,
    ...rest
  } = props;

  if (label && !id) {
    throw new Error('id required when a label is given');
  }

  const { valid, invalid, touched, error } = meta;

  // Error message and input error styles are only shown if the
  // field has been touched and the validation has failed.
  const hasError = touched && invalid && error;

  const selectClasses = classNames({
    [selectClassName]: selectClassName,
    [css.selectError]: hasError,
    [css.fieldMultiSelect]: true,
  });
  // Convert children to react-select options
  const options = childrenToOptions(children);

  // Find the selected option object
  const selectedOption = options.find(opt => opt.value === input.value) || null;

  // react-select onChange returns the option object
  const handleChange = option => {
    // For single select, option is either the option object or null
    const value = option ? option.value : '';
    input.onChange(value);
    if (onChange) {
      onChange(value);
    }
  };
  const selectProps = { className: selectClasses, id, ...input, onChange: handleChange, ...rest };

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      {label ? <label className={srOnly ? css.srOnly : null} htmlFor={id}>{label}</label> : null}
      <div className={classNames(css.inputWrapper, { [css.inputError]: hasError })} style={{ flex: 1 }}>
      <Select
        id={id}
        className={selectClasses}
        styles={customStyles}
        options={options}
        value={selectedOption}
        onChange={handleChange}
        isMulti={false}
        placeholder={placeholder}
        components={{
          Option: CustomOption,
        
        }}
        {...rest}
      />
      </div>
      {helperText && <p className={css.helperText}>{helperText}</p>}
      <ValidationError fieldMeta={meta} />
    </div>
  );
};

FieldSelectComponent.defaultProps = {
  rootClassName: null,
  className: null,
  selectClassName: null,
  id: null,
  label: null,
  helperText: null,
  children: null,
};

const { string, object, node } = PropTypes;

FieldSelectComponent.propTypes = {
  rootClassName: string,
  className: string,
  selectClassName: string,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string,
  label: string,

  helperText: string,

  // Generated by final-form's Field component
  input: object.isRequired,
  meta: object.isRequired,

  children: node,
};

const FieldSelect = props => {
  return <Field component={FieldSelectComponent} {...props} />;
};

export default FieldSelect;
